export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-namirialid.svg?d787f58d6f830786d4846cbee20f6d84";